import React, { useEffect, useState, useCallback, useMemo, useRef } from 'react'; // Importa useMemo
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import '../popup.css';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { FormControl, FormControlLabel, Grid } from '@material-ui/core';

import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import esLocale from '@fullcalendar/core/locales/es';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import { FileDownload, HandMove } from 'tabler-icons-react';
import * as jsonToExcel from 'xlsx';
import '../styles/calendar.css';

import {
    DataGrid,
    GridToolbarDensitySelector,
    GridToolbarFilterButton,
    esES,
} from '@material-ui/data-grid';
import { makeStyles } from '@material-ui/core/styles';
import Popper from '@material-ui/core/Popper';
import Fade from '@material-ui/core/Fade';
import Paper from '@material-ui/core/Paper';
import { Trash, Pencil, AlertTriangle, X } from 'tabler-icons-react';
import SearchIcon from '@material-ui/icons/Search';
import { CalendarMinus, CalendarEvent, CalendarStats, Search } from 'tabler-icons-react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';
import ModalR from '../components/ModalR.jsx';
import CellTooltip from '../components/CellTooltip.jsx';
import ModalS from '../components/ModalS.jsx';
import { MuiPickersUtilsProvider, KeyboardDateTimePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { format as fmtDate, isValid as isValidDate } from 'date-fns';

const setColor = (newColor) => {
    document.documentElement.style.setProperty('--color', newColor);
};

function escapeRegExp(value) {
    return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}

QuickSearchToolbar.propTypes = {
    clearSearch: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
};

function QuickSearchToolbar(props) {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <div>
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
            </div>
            <TextField
                variant="standard"
                fullWidth
                value={props.value}
                onChange={props.onChange}
                placeholder="Buscar..."
                size="small"
                // className={classes.textField}
                InputProps={{
                    startAdornment: <SearchIcon size="medium" />,
                    endAdornment: (
                        <IconButton
                            title="Clear"
                            aria-label="Clear"
                            size="medium"
                            className={props.value ? undefined : 'qs-clear-hidden'}
                            onClick={props.clearSearch}
                        >
                            <ClearIcon size="medium" />
                        </IconButton>
                    ),
                }}
            />
        </div>
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
}));

const useStyles1 = makeStyles((theme) => ({
    root: {
        width: '300px',
    },
    typography: {
        padding: theme.spacing(2),
        paddingTop: '0px',
        paddingLeft: '30px',
        width: '300px',
    },
}));

const useStyles2 = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
        margin: '20px 20px 0px 0px',
    },
}));

const useStyles3 = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        paddingLeft: '40px',
        paddingRight: '79px',
        paddingTop: '26px',
        fontFamily: 'WorkSans',
    },
    paper: {
        padding: theme.spacing(0),
        color: theme.palette.text.secondary,
        boxShadow: 'none',
    },
}));

const useStyles5 = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        paddingLeft: '40px',
        paddingRight: '79px',
        paddingTop: '26px',
        fontFamily: 'WorkSans',
    },
    paper: {
        padding: theme.spacing(2),
        color: theme.palette.text.secondary,
        boxShadow: 'none',
    },
}));

const useStyles6 = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(0),

        color: theme.palette.text.secondary,
        backgroundColor: '#f9fafc',
        boxShadow: 'none',
    },
}));

const useStyles9 = makeStyles((theme) => ({
    formControl: {
        width: '100%',
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const showCliente = process.env.REACT_APP_SHOW_CLIENTE_FIELD !== 'false';

const CalendarProduc = () => {
    const [lines, setLines] = useState([]);
    const [value, setValue] = useState('');
    const [calendarEvents, setCalendarEvents] = useState([]);
    const [open, setOpen] = useState(false);
    const [indi, setIndi] = useState(0);
    const [openPoper, setOpenPoper] = useState(false);
    const [openD, setOpenD] = useState(false);
    const [openP, setOpenP] = useState(false);
    const [openP1, setOpenP1] = useState(false);
    const [mensaje, setMensaje] = useState('');
    const [openM, setOpenM] = useState(false);
    const [openW, setOpenW] = useState(false);
    const [showContent, setShowContent] = useState(true);
    const [calendarWeeks, setCalendarWeeks] = useState('timeGridWeek');
    const [lineSelect, setSelectLine] = useState('');
    const [cantidadV, setCantidadV] = useState(0);
    const [ordenV, setOrdenV] = useState('');
    const [selectTipoCalenNombre, setSelectTipoCalenNombre] = useState('');
    const [skuV, setSkuV] = useState('');
    const [, setSkuNombreV] = useState('');
    const [duracionV, setDuracionV] = useState('');
    const [producidasV, setProducidasV] = useState('');
    const [enCalendarioV, setEncalendarioV] = useState('');
    const [restanV, setRestanV] = useState('');
    const [clienteV, setclienteV] = useState('');
    const [productoV, setProductoV] = useState('');
    const [tSetupV, setTSetupV] = useState('');
    const [metaV, setMetaV] = useState('');
    const [metaError, setMetaError] = useState('');
    const [openWarn, setOpenWarn] = useState(false);
    const [mensajeWarn, setMensajeWarn] = useState('');
    const [fechaIni, setFechaIni] = useState(0);
    const [fechaFin, setFechaFin] = useState(0);
    const [descServ, setDescServ] = useState('');
    const [tipoCalendarioIsSelect, setTipoCalendarioIsSelect] = useState('');
    const [selectedForm, setSelectedForm] = useState('orden');
    const [rows, setRows] = useState([]);
    const [tipoCalendario, setTipoCalendario] = useState([]);
    const [openS, setOpenS] = React.useState(false);
    const [openSuccess, setOpenSuccess] = React.useState(false);
    const [mensajeExito, setMensajeExito] = React.useState('');
    const [resW, setResW] = React.useState();
    const [isSavingService, setIsSavingService] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [corridaV, setCorridaV] = useState('');
    const [tipoEditV, setTipoEditV] = useState(1);
    const [fechaFinO, setFechaFinO] = useState('');
    const [orden, setOrden] = useState([]);
    const [arg, setArg] = useState([]);
    const [delOrdOrServ, setDelOrdOrServ] = useState([]);
    const [infOrder, setinfOrder] = useState([]);
    const [infEvent, setinfEvent] = useState('');
    const [selectedRows, setSelectedRows] = useState([]);
    const [checked, setChecked] = useState(false);
    const [openDefaultCapDialog, setOpenDefaultCapDialog] = useState(false);
    const [pendingOrderProps, setPendingOrderProps] = useState(null);
    const calendarComponentRef = useRef(); // Usa useRef para la ref del calendario
    const popUpSelectOrder = useRef();
    const dialogDRef = useRef();
    const dialogRef = useRef();

    // Optimiza tokenSessionObject para que sea estable en las renderizaciones
    const tokenSessionObject = useMemo(() => {
        try {
            return JSON.parse(sessionStorage.getItem('token'));
        } catch (error) {
            console.error('Failed to parse token from sessionStorage', error);
            return null;
        }
    }, []); // El array de dependencias vacío asegura que se calcule una vez

    const classes1 = useStyles1();
    useStyles2();
    const classes3 = useStyles3();
    const classes5 = useStyles5();
    const classes6 = useStyles6();
    const classes9 = useStyles9();
    const [searchText, setSearchText] = useState('');
    const [openT, setOpenT] = React.useState(false);

    const [fechaFinE, setFechaFinE] = React.useState(true);
    const [anchorEle, setAnchorEl] = React.useState(null);
    const [paroAnchorEl, setParoAnchorEl] = useState(null);
    let primColor = '';
    if (process.env.REACT_APP_THEME === 'tecnoTheme') {
        primColor = '#ff9800';
        setColor(primColor);
    } else if (process.env.REACT_APP_THEME === 'posTheme') {
        primColor = '#00638D';
        setColor(primColor);
    } else if (process.env.REACT_APP_THEME === 'vaisandTheme') {
        primColor = '#1959D9';
        setColor(primColor);
    } else {
        primColor = '#903bff';
        setColor(primColor);
    }

    // Función auxiliar para convertir fecha a UTC
    const convertToUTC = (dateString) => {
        // Si la fecha ya viene en formato ISO completo, convertir directamente
        const date = new Date(dateString);
        return `${date.toISOString().slice(0, 16)}Z`;
    };

    const toIsoStringOrNull = (dateValue) => {
        const date = new Date(dateValue);
        if (Number.isNaN(date.getTime())) {
            return null;
        }
        return date.toISOString();
    };

    const handleChangeCheck = (event) => {
        setChecked(event.target.checked);
        setFechaFinE(!fechaFinE);
    };

    const handleParoOpen = (event) => {
        setParoAnchorEl(event.currentTarget);
    };

    const handleParoClose = () => {
        setParoAnchorEl(null);
    };

    const handleChangeParoAut = (event, data) => {
        setTipoCalendarioIsSelect(event.target.value);
        setSelectTipoCalenNombre(tipoCalendario[data.props.id].nombre);
    };

    const ExportToExcel = () => {
        const data = [];
        calendarEvents.forEach((calendarEvent, index) => {
            if (calendarEvent.tipo === 1) {
                data[index] = {
                    Orden: calendarEvent.title,
                    'Fecha Inicio': calendarEvent.start,
                    'Fecha Final': calendarEvent.end,
                    Cantidad: calendarEvent.cantidad,
                    'Fecha posible de entrega': calendarEvent.fechaEntrega,
                    Cliente: calendarEvent.cliente,
                    Meta: calendarEvent.meta,
                    sku: calendarEvent.sku,
                    'sku Nombre': calendarEvent.producto,
                };
            }
        });

        const worksheet = jsonToExcel.utils.json_to_sheet(data);
        const workbook = jsonToExcel.utils.book_new();
        jsonToExcel.utils.book_append_sheet(workbook, worksheet, 'Hoja1');
        jsonToExcel.writeFile(workbook, 'Ordenes_Programadas.xlsx');
    };

    const funcionEventos = useCallback((ordenesF) => {
        let newArray = [];
        let titulo = '';
        let sku = '';
        let skuNombre = '';
        ordenesF.map((item) => {
            // El contrato omite las llaves nulas del JSON: guardamos contra ausencias.
            const fechaEntrega = item.fechaEntrega ? item.fechaEntrega.split('T') : [''];
            if (item.tipo >= 2) {
                titulo = item.descripcion || '';
            } else {
                titulo = item.ordenProd || '';
                sku = item.sku || '';
                skuNombre = item.nombreSku || '';
            }
            newArray = [
                ...newArray,
                {
                    title: titulo,
                    start: item.fechaIni.toLocaleString(),
                    end: item.fechaFin.toLocaleString(),
                    backgroundColor: functionColor(item.tipo, item.estado),
                    borderColor: functionBorderColor(item.tipo, item.estado),
                    classNames:
                        item.tipo === 1 && item.estado === 'EnEjecucion'
                            ? ['cal-event--enejecucion']
                            : [],
                    corrida: item.corrida,
                    descripcion: item.descripcion,
                    tipo: item.tipo,
                    tiempoSetup: item.tiempoSetup,
                    cantidad: item.cantidad,
                    fechaEntrega: fechaEntrega[0],
                    cliente: item.cliente,
                    meta: item.meta,
                    sku: sku,
                    producto: skuNombre,
                    estado: item.estado,
                    producido: item.producido,
                },
            ];
            return newArray;
        }); // Se eliminó el return newArray innecesario fuera de map
        setCalendarEvents([]);
        setCalendarEvents(newArray);
        setShowContent(true);
        setSelectedForm('orden');
    }, []); // No hay dependencias externas aquí, estos setters de estado son estables

    // Solo las órdenes (tipo 1) se diferencian por estado de ejecución (NOVA-26):
    // Cerrada = verde más oscuro; EnEjecucion = verde más claro; SinIniciar = normal.
    const functionColor = (tipo, estado) => {
        let color = '';
        if (tipo >= 2) {
            color = '#D4A800';
        } else {
            switch (tipo) {
                case 0:
                    color = '#FADD72';
                    break;
                case 1:
                    if (estado === 'Cerrada') color = '#1F9E79';
                    else if (estado === 'EnEjecucion') color = '#7FE3C8';
                    else color = '#2CCB9E';
                    break;
                default:
                    color = '#CCCCCC';
                    break;
            }
        }
        return color;
    };

    const functionBorderColor = (tipo, estado) => {
        if (tipo >= 2) return '#A07800';
        switch (tipo) {
            case 0:
                return '#BFA030';
            case 1:
                if (estado === 'Cerrada') return '#166F55';
                return '#1A9B72';
            default:
                return '#9E9E9E';
        }
    };

    // Celda con elipsis + tooltip: si el texto no cabe, se trunca y al pasar el
    // cursor se ve el valor completo (CellTooltip se renderiza vía portal, no
    // depende del portal de MUI Tooltip que no aparece dentro del Modal).
    const renderEllipsisCell = (params) => {
        const text = params.value != null ? String(params.value) : '';
        return (
            <CellTooltip className="cal-cell-ellipsis" title={text}>
                {params.value}
            </CellTooltip>
        );
    };

    // El servicio envía la fecha en UTC (sin zona); la interpretamos como UTC y
    // la mostramos en la hora local del navegador.
    const toLocalDateTime = (value) => {
        if (value == null || value === '') {
            return '';
        }
        const str = String(value);
        const hasTz = /[zZ]$|[+-]\d{2}:?\d{2}$/.test(str);
        const date = new Date(hasTz ? str : `${str}Z`);
        return isValidDate(date) ? fmtDate(date, 'dd/MM/yyyy HH:mm') : str;
    };

    const renderFechaCell = (params) => {
        const text = toLocalDateTime(params.value);
        return (
            <CellTooltip className="cal-cell-ellipsis" title={text}>
                {text}
            </CellTooltip>
        );
    };

    // Header con elipsis + tooltip: aunque la columna sea angosta, el nombre
    // completo del encabezado se ve al pasar el cursor.
    const renderHeaderTooltip = (params) => (
        <CellTooltip
            className="cal-cell-ellipsis cal-header-ellipsis"
            title={params.colDef.headerName}
        >
            {params.colDef.headerName}
        </CellTooltip>
    );

    const baseColumns = [
        {
            field: 'ordenProd',
            headerName: 'Orden',
            flex: 0.8,
            minWidth: 90,
            editable: false,
            renderCell: renderEllipsisCell,
        },
        ...(showCliente
            ? [
                  {
                      field: 'cliente',
                      headerName: 'Cliente',
                      flex: 1.3,
                      minWidth: 140,
                      editable: true,
                      renderCell: renderEllipsisCell,
                  },
              ]
            : []),
        {
            field: 'sku',
            headerName: 'Sku',
            flex: 0.8,
            minWidth: 90,
            editable: true,
            renderCell: renderEllipsisCell,
        },
        {
            field: 'skuNombre',
            headerName: 'Nombre',
            flex: 1.1,
            minWidth: 130,
            editable: false,
            renderCell: renderEllipsisCell,
        },
        {
            field: 'cantidad',
            headerName: 'Total',
            flex: 0.6,
            minWidth: 85,
            align: 'center',
            editable: true,
        },
        {
            field: 'producido',
            headerName: 'Producido',
            flex: 0.75,
            minWidth: 115,
            align: 'center',
            editable: false,
        },
        {
            field: 'cantidadCalendario',
            headerName: 'En Calendario',
            flex: 1,
            minWidth: 130,
            align: 'center',
            editable: true,
        },
        {
            field: 'restan',
            headerName: 'Restan',
            flex: 0.65,
            minWidth: 100,
            align: 'center',
            editable: true,
        },
        {
            field: 'fecha',
            headerName: 'Fecha',
            flex: 1.1,
            minWidth: 130,
            editable: false,
            renderCell: renderFechaCell,
        },
    ];

    // El encabezado se alinea igual que el dato (numéricos centrados) y todos
    // los headers reciben tooltip por si el ancho disponible los recorta.
    const columns = baseColumns.map((col) => ({
        headerAlign: col.align,
        renderHeader: renderHeaderTooltip,
        ...col,
    }));

    const getLines = useCallback(async () => {
        const data = await fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT}/lineas`, {
            method: 'GET',
            headers: {
                authorization: `Bearer ${tokenSessionObject.token}`,
                Accept: 'application/json',
            },
        });
        const lines = await data.json();

        setLines(lines);
    }, [tokenSessionObject.token]); // Dependencia de tokenSessionObject.token

    const SearchOrder = async (searchOrder) => {
        setOpenPoper(false);
        setValue(searchOrder);
        let date = calendarComponentRef.current.getApi();
        const data = await fetch(
            `${process.env.REACT_APP_SERVICE_ENDPOINT}/Calendario/ordenEspecifica?orden=${searchOrder}`,
            {
                method: 'GET',
                headers: {
                    authorization: `Bearer ${tokenSessionObject.token}`,
                    Accept: 'application/json',
                },
            }
        );
        const SearchOrder = await data.json();
        if (data.status === 200 && SearchOrder.length > 0) {
            if (SearchOrder[0].linea !== null || SearchOrder[0].linea !== '') {
                setSelectLine(SearchOrder[0].linea);
            }
            date.gotoDate(SearchOrder[0].fechaIni);
            funcionEventos(SearchOrder);
        }
    };

    const handleClickT = () => {
        setOpenT(true);
    };

    const handleCloseT = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenT(false);
    };

    const handleDateUpdateEvents = useCallback(
        async (line) => {
            const linSel = line != null ? line : lineSelect;
            // Sin línea seleccionada no hay nada que consultar; evita el request
            // ordenesFecha?linea= vacío que el backend rechaza con 400.
            if (linSel === '' || linSel == null) {
                return;
            }

            // Asegúrate de que calendarComponentRef.current no sea nulo antes de continuar
            if (!calendarComponentRef.current) {
                return;
            }

            let _start = new Date(
                calendarComponentRef.current.getApi().currentDataManager.data.dateProfile
                    .renderRange.start
            )
                .toISOString()
                .slice(0, 10);

            let _end = new Date(
                calendarComponentRef.current.getApi().currentDataManager.data.dateProfile
                    .renderRange.end
            );
            _end.setDate(_end.getDate() + 4);
            const _end1 = new Date(_end).toISOString().slice(0, 10);
            const data = await fetch(
                `${process.env.REACT_APP_SERVICE_ENDPOINT}/Calendario/ordenesFecha?linea=${linSel}&start=${_start}&end=${_end1}`,
                {
                    method: 'GET',
                    headers: {
                        authorization: `Bearer ${tokenSessionObject.token}`,
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                }
            );

            const ordenes = await data.json();
            if (data.status !== 400) {
                funcionEventos(ordenes);
            }
        },
        [calendarComponentRef, funcionEventos, lineSelect, tokenSessionObject.token]
    ); // Dependencias

    const orderSin = useCallback(async () => {
        const data = await fetch(
            `${process.env.REACT_APP_SERVICE_ENDPOINT}/Calendario/ordenesSinProgramar`,
            {
                method: 'GET',
                headers: {
                    authorization: `Bearer ${tokenSessionObject.token}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            }
        );
        const filas = await data.json();

        if (filas.length !== 0) {
            const data = [];
            handleClickT();
            filas.forEach((fila, index) => {
                data[index] = {
                    cantidad: fila.cantidad,
                    cantidadCalendario: fila.cantidadCalendario,
                    estatus: fila.estatus,
                    fecha: fila.fecha,
                    id: fila.id,
                    ordenProd: fila.ordenProd,
                    sku: fila.sku,
                    skuNombre: fila.skuNombre,
                    restan: fila.restan,
                    cliente: fila.cliente,
                    producido: fila.producido,
                };
            });

            setOrden(data);
            setRows(data);
        }

        // setRows(filasPrueba);
    }, [tokenSessionObject.token]); // Dependencia de tokenSessionObject.token

    const handleClose = () => {
        setOpen(false);
    };

    const handleCloseD = () => {
        setOpenD(false);
    };

    const handleDrop = async (arg, flag) => {
        setArg(arg);
        const fechaSelec = new Date(arg.event.startStr);
        const fechaOld = new Date(arg.oldEvent.startStr);
        const fechaActual = new Date(Date.now());
        const diff = fechaSelec - fechaActual;
        const diffOld = fechaOld - fechaActual;

        if (diff <= 0) {
            arg.revert();
        } else {
            if (diffOld <= 0) {
                setOpenW(true);
            } else {
                let orPro = 0;
                if (arg.event.extendedProps.tipo >= 2) {
                    orPro = null;
                } else {
                    orPro = arg.event.title;
                }

                const delOrOSer = {
                    corrida: arg.event.extendedProps.corrida,
                    linea: lineSelect,
                    ordenProd: orPro,
                    tipo: arg.event.extendedProps.tipo,
                    fechaIni: convertToUTC(arg.event.startStr),
                    fechaFin: convertToUTC(arg.event.endStr),
                    tiempoSetup: arg.event.extendedProps.tiempoSetup,
                    meta: 0,
                    descripcion: arg.event.extendedProps.descripcion,
                    cantidad: arg.event.extendedProps.cantidad,
                };

                fetch(
                    `${process.env.REACT_APP_SERVICE_ENDPOINT}/Calendario/editarOrdenProgramada`,
                    {
                        method: 'PUT',
                        body: JSON.stringify(delOrOSer),
                        headers: {
                            authorization: `Bearer ${tokenSessionObject.token}`,
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                        },
                    }
                ).then(async (response) => {
                    const isJson = response.headers
                        .get('content-type')
                        ?.includes('application/json');
                    const data1 = isJson && (await response.json());

                    // check for error response
                    if (!response.ok) {
                        // get error message from body or default to response status
                        const error = (data1 && data1.message) || response.status;
                        return Promise.reject(error);
                    } else {
                        // if (flag == 0) {
                        //     handleDateUpdateEvents();
                        // }
                    }
                });
            }
        }
    };

    const handleClick = (arg) => {
        let titulo = '';
        setAnchorEl(arg.el);
        document.documentElement.style.setProperty(
            '--popper-event-color',
            arg.event.backgroundColor
        );
        if (arg.event.extendedProps.tipo >= 2) {
            titulo = `Descripcion: ${arg.event.extendedProps.descripcion}`;
            const OrdenSel = [
                titulo,
                // 'linea:' + lineSelect,
                // `Total: ${arg.event.extendedProps.cantidad}`,
                // `Corrida: ${arg.event.extendedProps.corrida}`,
                // `Meta: ${arg.event.extendedProps.meta}`,
                `Fecha: ${arg.event.startStr.slice(0, 10)}`,
                `Hora de inicio: ${arg.event.startStr.slice(11, 16)}`,
                `Hora de finalizacion: ${arg.event.endStr.slice(11, 16)}`,
                // `Tiempo Setup: ${arg.event.extendedProps.tiempoSetup}`,
            ];
            setDelOrdOrServ(arg.event);
            setinfOrder(OrdenSel);
            setOpenPoper(openPoper ? false : true);
        } else {
            titulo = `Orden: ${arg.event.title}`;
            const estado = arg.event.extendedProps.estado;
            const producido = arg.event.extendedProps.producido;
            const estadoLabel =
                estado === 'EnEjecucion'
                    ? 'En ejecución'
                    : estado === 'Cerrada'
                      ? 'Cerrada'
                      : 'Sin ejecutar';
            const estadoInfo =
                estado === 'EnEjecucion' || estado === 'Cerrada'
                    ? [`Estado: ${estadoLabel}`, `Producido: ${producido ?? 0}`]
                    : ['Estado: Sin ejecutar'];
            const OrdenSel = [
                titulo,
                ...(showCliente ? [`Cliente: ${arg.event.extendedProps.cliente}`] : []),
                `Sku: ${arg.event.extendedProps.sku}`,
                `Nombre: ${arg.event.extendedProps.producto}`,
                ...estadoInfo,

                // 'linea:' + lineSelect,
                `Total: ${arg.event.extendedProps.cantidad}`,
                // `Corrida: ${arg.event.extendedProps.corrida}`,
                `Meta: ${arg.event.extendedProps.meta}`,
                // `Fecha de inicio: ${arg.event.startStr.slice(0, 10)}`,
                // `Hora de inicio: ${arg.event.startStr.slice(11, 16)}`,
                // `Hora de finalización: ${arg.event.endStr.slice(0, 10)}`,
                `Fecha inicio: ${arg.event.startStr.slice(0, 10)} ${arg.event.startStr.slice(
                    11,
                    16
                )}`,
                `Fecha finalización: ${arg.event.endStr.slice(0, 10)} ${arg.event.endStr.slice(
                    11,
                    16
                )}`,
                // `Tiempo Setup: ${arg.event.extendedProps.tiempoSetup}`,
            ];

            setDelOrdOrServ(arg.event);
            setinfOrder(OrdenSel);
            setOpenPoper(openPoper ? false : true);
        }
    };

    const handleSelect = (info) => {
        setOpenPoper(false);
        const fechaSelec = new Date(info.startStr);
        const fechaActual = new Date(Date.now());
        const diff = fechaSelec - fechaActual;
        if (diff <= 0) {
            setMensaje('La fecha y hora seleccionada debe ser mayor a la fecha y hora actual !!!');
            setOpenS(true);
        } else {
            const fecha = `Esta seguro que desea crear un evento para la fecha: ${info.startStr.slice(
                8,
                10
            )}/${info.startStr.slice(5, 7)}/${info.startStr.slice(
                0,
                4
            )} en el horario: ${info.startStr.slice(11, 16)} ?`;

            // orderSin();
            setinfEvent(fecha);
            setFechaIni(info.startStr.slice(0, 16));

            const hora = parseInt(info.startStr.slice(12, 13), 10) + 1;

            const fechaFinServicio =
                info.startStr.slice(0, 12) + hora + info.startStr.slice(13, 16);

            setFechaFin(fechaFinServicio);
            setOpenD(true);
        }
    };

    const handleDataSelect = (info) => {
        if (info.length > 1) {
            const selectionSet = new Set(selectedRows);
            const result = info.filter((s) => !selectionSet.has(s));

            setSelectedRows(result);
        } else {
            setSelectedRows(info);
        }
    };

    const showformOrden = (event) => {
        if (event.target.value === 'orden') {
            setShowContent(true);
            setSelectedForm('orden');
        } else {
            setShowContent(false);
            setSelectedForm('servicio');
        }
    };

    const handleCloseS = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenS(false);
        setMensaje('');
    };

    const handleCloseSuccess = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSuccess(false);
    };

    const getFechafin = async (props) => {
        const diff = props[0].restan;
        const data = await fetch(
            `${process.env.REACT_APP_SERVICE_ENDPOINT}/Calendario/CalcularFechaFin?orden=${props[0].ordenProd}&linea=${lineSelect}&meta=${diff}`,
            {
                method: 'GET',
                headers: {
                    authorization: `Bearer ${tokenSessionObject.token}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            }
        );
        if (data.status === 404) {
            setPendingOrderProps(props);
            setOpenDefaultCapDialog(true);
            return;
        }
        const CalFechaFin = await data.json();

        const data1 = await fetch(
            `${process.env.REACT_APP_SERVICE_ENDPOINT}/productos/GetProductoSku?sku=${props[0].sku}`,
            {
                method: 'GET',
                headers: {
                    authorization: `Bearer ${tokenSessionObject.token}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            }
        );
        const producto = await data1.json();

        setDuracionV(CalFechaFin);
        const fecIni = new Date(fechaIni);
        const fechaFinComp = new Date(fecIni.getTime() + CalFechaFin * 60000);
        let dia = fechaFinComp.getDate();
        let mes = fechaFinComp.getMonth() + 1;
        let hora = fechaFinComp.getHours();
        let min = fechaFinComp.getMinutes();
        if (dia <= 9) {
            dia = `0${dia}`;
        }
        if (mes <= 9) {
            mes = `0${mes}`;
        }
        if (hora <= 9) {
            hora = `0${hora}`;
        }
        if (min <= 9) {
            min = `0${min}`;
        }

        setFechaFinO(`${fechaFinComp.getFullYear()}-${mes}-${dia}T${hora}:${min}`);
        setCantidadV(props[0].cantidad);
        setMetaV(props[0].restan);
        setRestanV(props[0].restan);

        setOrdenV(props[0].ordenProd);
        setSkuV(props[0].sku);
        setProducidasV(props[0].producido);
        setProductoV(producto.nombre);
        setTSetupV(0);
        setEncalendarioV(props[0].cantidadCalendario);
        setclienteV(props[0].cliente);

        setOpenP1(false);
        setSelectedRows([]);
    };

    const getFechafinConDefaults = async (props) => {
        const data1 = await fetch(
            `${process.env.REACT_APP_SERVICE_ENDPOINT}/productos/GetProductoSku?sku=${props[0].sku}`,
            {
                method: 'GET',
                headers: {
                    authorization: `Bearer ${tokenSessionObject.token}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            }
        );
        const producto = await data1.json();

        const capData = await fetch(
            `${process.env.REACT_APP_SERVICE_ENDPOINT}/capacidadesdefault`,
            {
                method: 'GET',
                headers: {
                    authorization: `Bearer ${tokenSessionObject.token}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            }
        );
        // El GET es un volcado completo (sin filtro por línea en el back); se filtra en el cliente.
        const capacidadesList = await capData.json();
        const capacidades = (Array.isArray(capacidadesList) ? capacidadesList : []).find(
            (c) => Number(c.linea) === Number(lineSelect)
        ) || { ritmoEstandar: 0 };

        const diff = props[0].restan;

        const duracionMin =
            capacidades.ritmoEstandar > 0 ? Math.round((diff / capacidades.ritmoEstandar) * 60) : 0;

        setDuracionV(duracionMin);
        const fecIni = new Date(fechaIni);
        const fechaFinComp = new Date(fecIni.getTime() + duracionMin * 60000);
        let dia = fechaFinComp.getDate();
        let mes = fechaFinComp.getMonth() + 1;
        let hora = fechaFinComp.getHours();
        let min = fechaFinComp.getMinutes();
        if (dia <= 9) dia = `0${dia}`;
        if (mes <= 9) mes = `0${mes}`;
        if (hora <= 9) hora = `0${hora}`;
        if (min <= 9) min = `0${min}`;

        setFechaFinO(`${fechaFinComp.getFullYear()}-${mes}-${dia}T${hora}:${min}`);
        setCantidadV(props[0].cantidad);
        setMetaV(props[0].restan);
        setRestanV(props[0].restan);
        setOrdenV(props[0].ordenProd);
        setSkuV(props[0].sku);
        setProducidasV(props[0].producido);
        setProductoV(producto.nombre);
        setTSetupV(0);
        setEncalendarioV(props[0].cantidadCalendario);
        setclienteV(props[0].cliente);
        setOpenP1(false);
        setSelectedRows([]);
    };

    const getLineaOptima = (props) => {
        getFechafin(props);
    };

    const handleSelOrder = () => {
        requestSearch('');
        if (selectedRows.length > 0) {
            const datos = orden.filter((ord) => ord.id === selectedRows[0]); // Cambiado a [0] ya que solo se puede seleccionar un pedido
            getLineaOptima(datos);
            setOpenP1(false);
        } else {
            alert('Debe seleccionar una orden de la lista');
        }
    };

    const putOrder = async () => {
        const fechaIniIso = toIsoStringOrNull(fechaIni);
        const fechaFinIso = toIsoStringOrNull(fechaFinO);
        if (!fechaIniIso || !fechaFinIso) {
            setMensaje('Debe seleccionar fecha inicial y final válidas.');
            setOpenS(true);
            return;
        }

        if (isEditing) {
            const data = {
                corrida: corridaV,
                linea: lineSelect,
                ordenProd: ordenV,
                tipo: tipoEditV,
                fechaIni: convertToUTC(fechaIni),
                fechaFin: convertToUTC(fechaFinO),
                tiempoSetup: Number(tSetupV) || 0,
                meta: Number(metaV) || 0,
                descripcion: '',
                cantidad: cantidadV,
            };
            fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT}/Calendario/editarOrdenProgramada`, {
                method: 'PUT',
                body: JSON.stringify(data),
                headers: {
                    authorization: `Bearer ${tokenSessionObject.token}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            })
                .then(async (response) => {
                    const isJson = response.headers
                        .get('content-type')
                        ?.includes('application/json');
                    const data1 = isJson && (await response.json());
                    if (!response.ok) {
                        const error = (data1 && data1.message) || response.status;
                        setMensaje(String(error));
                        setOpenS(true);
                    } else {
                        setMensajeExito('Orden editada correctamente.');
                        setOpenSuccess(true);
                        handleDateUpdateEvents();
                        handleCloseP();
                    }
                })
                .catch(() => {
                    setMensaje('No se pudo editar la orden. Intente nuevamente.');
                    setOpenS(true);
                });
            return;
        }

        const data = {
            linea: lineSelect,
            ordenProd: ordenV,
            tipo: 1,
            fechaIni: fechaIniIso,
            fechaFin: fechaFinIso,
            tiempoSetup: tSetupV,
            meta: metaV,
            descripcion: '',
        };

        fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT}/Calendario/programarOrden`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                authorization: `Bearer ${tokenSessionObject.token}`,
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        }).then(async (response) => {
            const isJson = response.headers.get('content-type')?.includes('application/json');
            const data1 = isJson && (await response.json());

            // check for error response
            if (!response.ok) {
                // get error message from body or default to response status
                const error = (data1 && data1.message) || response.status;
                return Promise.reject(error);
            } else {
                // window.location.replace('');
                handleDateUpdateEvents();
                setOpenP(false);
                setOrdenV('');
                setSkuV('');
                setSkuNombreV('');
                setCantidadV('');
                setDuracionV('');
                setProductoV(' ');
                setFechaFinO('');
                setTSetupV('');
                setMetaV('');
                setProducidasV('');
                setEncalendarioV();
                setRestanV('');
                setclienteV('');
                orderSin('');
            }
        });
    };

    const handleResW = (res) => {
        setResW(res);
        setOpenW(false);
    };

    const postNewOrd = (info) => {
        info.preventDefault();
        putOrder();
    };

    const postNewService = (info) => {
        info.preventDefault();

        const fechaIniIso = toIsoStringOrNull(fechaIni);
        const fechaFinIso = toIsoStringOrNull(fechaFin);
        if (!fechaIniIso || !fechaFinIso) {
            setMensaje('Debe seleccionar fecha inicial y final válidas.');
            setOpenS(true);
            return;
        }

        if (isEditing) {
            const data = {
                corrida: corridaV,
                linea: lineSelect,
                ordenProd: null,
                tipo: tipoEditV,
                fechaIni: convertToUTC(fechaIni),
                fechaFin: convertToUTC(fechaFin),
                tiempoSetup: 0,
                meta: 0,
                descripcion: descServ || selectTipoCalenNombre,
                cantidad: cantidadV,
            };
            fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT}/Calendario/editarOrdenProgramada`, {
                method: 'PUT',
                body: JSON.stringify(data),
                headers: {
                    authorization: `Bearer ${tokenSessionObject.token}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            })
                .then(async (response) => {
                    const isJson = response.headers
                        .get('content-type')
                        ?.includes('application/json');
                    const data1 = isJson && (await response.json());
                    if (!response.ok) {
                        const error = (data1 && data1.message) || response.status;
                        setMensaje(String(error));
                        setOpenS(true);
                    } else {
                        setMensajeExito('Servicio editado correctamente.');
                        setOpenSuccess(true);
                        handleDateUpdateEvents();
                        handleCloseP();
                    }
                })
                .catch(() => {
                    setMensaje('No se pudo editar el servicio. Intente nuevamente.');
                    setOpenS(true);
                });
            return;
        }

        const servicio = {
            linea: lineSelect,
            ordenProd: null,
            tipo: tipoCalendarioIsSelect + 2,
            fechaIni: fechaIniIso,
            fechaFin: fechaFinIso,
            tiempoSetup: 0,
            meta: 0,
            descripcion: selectTipoCalenNombre,
        };

        setNewService(servicio);
    };

    const setNewService = async (data) => {
        setIsSavingService(true);
        fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT}/Calendario/AsignarLineaServicio`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                authorization: `Bearer ${tokenSessionObject.token}`,
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        })
            .then(async (response) => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data1 = isJson && (await response.json());

                // check for error response
                if (!response.ok) {
                    // get error message from body or default to response status
                    const error = (data1 && data1.message) || response.status;
                    return Promise.reject(error);
                } else {
                    // window.location.replace('');
                    handleDateUpdateEvents();
                    setDescServ('');
                    setTipoCalendarioIsSelect('');
                    setSelectTipoCalenNombre('');
                    setFechaIni('');
                    setFechaFin('');
                    setOpenP(false);
                    orderSin();
                }
            })
            .catch(() => {
                setMensaje('No se pudo crear el servicio. Intente nuevamente.');
                setOpenS(true);
            })
            .finally(() => {
                setIsSavingService(false);
            });
    };

    const deleteOrder = async (props) => {
        await fetch(
            `${process.env.REACT_APP_SERVICE_ENDPOINT}/Calendario/EliminarOrdenCalendario?corrida=${props[0]}`,
            {
                method: 'PUT',
                headers: {
                    authorization: `Bearer ${tokenSessionObject.token}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            }
        )
            .then((res) => res.json())
            .catch((error) => console.error('Error: ', error))
            .then((response) => {
                // window.location.replace(''); //refrescamos la página
                handleDateUpdateEvents();
                setOpenPoper(false);
                setOpenM(false);
                orderSin();
            });
    };

    const handleCloseM = () => {
        setOpenM(false);
        setOpenPoper(false);
    };

    const handleOpenM = () => {
        // const fechaSelec = new Date(delOrdOrServ.startStr);
        // const fechaActual = new Date(Date.now());
        // const diff = fechaSelec - fechaActual;
        // no permite borrar corridas anteriores a la fecha actual
        // if (diff <= 0) {
        //     setMensaje('No puede eliminar una Orden/Servicio con fecha anterior a la fecha actual');
        //     setOpenS(true);
        // } else {
        //     setOpenM(true);
        // }
        setOpenM(true);
    };

    const deleteService = async (props) => {
        await fetch(
            `${process.env.REACT_APP_SERVICE_ENDPOINT}/Calendario/EliminarOrdenCalendario?corrida=${props[0]}`,
            {
                method: 'PUT',
                headers: {
                    authorization: `Bearer ${tokenSessionObject.token}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            }
        )
            .then((res) => res.json())
            .catch((error) => console.error('Error: ', error))
            .then((response) => {
                // window.location.replace(''); //refrescamos la página
                handleDateUpdateEvents();
                setOpenPoper(false);
                setOpenM(false);
                orderSin();
            });
    };

    const deleteOrderOrService = async () => {
        if (delOrdOrServ.extendedProps.tipo >= 2) {
            deleteService([
                delOrdOrServ.extendedProps.corrida,
                delOrdOrServ.extendedProps.descripcion,
            ]);
        } else {
            deleteOrder([delOrdOrServ.extendedProps.corrida, delOrdOrServ.title]);
        }
    };

    const requestSearch = async (searchValue) => {
        setSearchText(searchValue);
        const searchRegex = new RegExp(escapeRegExp(searchValue), 'i');
        const filteredRows = orden.filter((row) => {
            return Object.keys(row).some((field) => {
                return searchRegex.test(row[field]);
            });
        });
        setRows(filteredRows);
    };

    const handlePopUpP = () => {
        setOpenP(true);
        setOpenD(false);
    };

    const calcFechaFin = useCallback(
        async (ordenProd, linea, meta, startIso) => {
            try {
                const data = await fetch(
                    `${process.env.REACT_APP_SERVICE_ENDPOINT}/Calendario/CalcularFechaFin?orden=${ordenProd}&linea=${linea}&meta=${meta}`,
                    {
                        method: 'GET',
                        headers: {
                            authorization: `Bearer ${tokenSessionObject.token}`,
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                        },
                    }
                );
                if (!data.ok) return;
                const duration = await data.json();
                setDuracionV(duration);
                const fecIni = new Date(startIso);
                const fechaFinComp = new Date(fecIni.getTime() + duration * 60000);
                let dia = fechaFinComp.getDate();
                let mes = fechaFinComp.getMonth() + 1;
                let hora = fechaFinComp.getHours();
                let min = fechaFinComp.getMinutes();
                if (dia <= 9) dia = `0${dia}`;
                if (mes <= 9) mes = `0${mes}`;
                if (hora <= 9) hora = `0${hora}`;
                if (min <= 9) min = `0${min}`;
                setFechaFinO(`${fechaFinComp.getFullYear()}-${mes}-${dia}T${hora}:${min}`);
            } catch (_) {}
        },
        [tokenSessionObject.token]
    );

    const getfechaFinMeta = useCallback(
        async (meta) => {
            const data = await fetch(
                `${process.env.REACT_APP_SERVICE_ENDPOINT}/Calendario/CalcularFechaFin?orden=${ordenV}&linea=${lineSelect}&meta=${meta}`,
                {
                    method: 'GET',
                    headers: {
                        authorization: `Bearer ${tokenSessionObject.token}`,
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                }
            );
            const CalFechaFinMeta = await data.json();

            setDuracionV(CalFechaFinMeta);
            const fecIni = new Date(fechaIni);

            const fechaFinComp = new Date(fecIni.getTime() + CalFechaFinMeta * 60000);
            let dia = fechaFinComp.getDate();
            let mes = fechaFinComp.getMonth() + 1;
            let hora = fechaFinComp.getHours();
            let min = fechaFinComp.getMinutes();
            if (dia <= 9) {
                dia = `0${dia}`;
            }
            if (mes <= 9) {
                mes = `0${mes}`;
            }
            if (hora <= 9) {
                hora = `0${hora}`;
            }
            if (min <= 9) {
                min = `0${min}`;
            }

            setFechaFinO(`${fechaFinComp.getFullYear()}-${mes}-${dia}T${hora}:${min}`);
        },
        [fechaIni, lineSelect, ordenV, tokenSessionObject.token]
    ); // Se agregaron dependencias a useCallback

    // Función de debounce
    const debounce = (func, delay) => {
        let timeout;
        return function (...args) {
            const context = this;
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(context, args), delay);
        };
    };

    const debouncedGetFechaFinMeta = useMemo(
        () => debounce(getfechaFinMeta, 500),
        [getfechaFinMeta]
    );

    const handleMeta = (e) => {
        const value = e.target.value;
        if (value === '') {
            setMetaV('');
            setMetaError('');
            setDuracionV(''); // Borra la duración si la meta se borra
            setFechaFinO(''); // Borra la fecha de finalización si la meta se borra
            return;
        }
        if (Number(value) < 0) {
            setMetaError('La meta no puede ser un valor negativo.');
            setMensajeWarn('La meta no puede ser un valor negativo.');
            setOpenWarn(true);
            return;
        }
        if (!isEditing && Number(value) > Number(restanV)) {
            setMetaError(`La meta debe ser menor o igual a las ${restanV} unidades restantes.`);
            setMensajeWarn(`La meta debe ser menor o igual a las ${restanV} unidades restantes.`);
            setOpenWarn(true);
            return;
        }
        setMetaError('');
        setMetaV(value);
        debouncedGetFechaFinMeta(value); // Llama a la versión debounced
    };

    const handleCloseWarn = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenWarn(false);
    };

    const handleCloseP = () => {
        setOpenP(false);
        setIsEditing(false);
        setCorridaV('');
        setOrdenV('');
        setSkuV('');
        setSkuNombreV('');
        setCantidadV('');
        setDuracionV('');
        setProductoV(' ');
        setFechaFinO('');
        setFechaIni('');
        setFechaFin('');
        setTSetupV('');
        setMetaV('');
        setMetaError('');
        setProducidasV('');
        setEncalendarioV('');
        setRestanV('');
        setclienteV('');
        setDescServ('');
    };

    const handleEditEvent = () => {
        const event = delOrdOrServ;
        const tipo = event.extendedProps.tipo;
        const startLocal = event.startStr.slice(0, 16);
        const endLocal = event.endStr.slice(0, 16);

        setIsEditing(true);
        setCorridaV(event.extendedProps.corrida);
        setTipoEditV(tipo);
        setFechaIni(startLocal);

        if (tipo >= 2) {
            setSelectedForm('servicio');
            setShowContent(false);
            setDescServ(event.extendedProps.descripcion || '');
            setFechaFin(endLocal);
            setCantidadV(event.extendedProps.cantidad || 0);
        } else {
            setSelectedForm('orden');
            setShowContent(true);
            setOrdenV(event.title || '');
            setSkuV(event.extendedProps.sku || '');
            setProductoV(event.extendedProps.producto || '');
            setCantidadV(event.extendedProps.cantidad || 0);
            setRestanV(event.extendedProps.cantidad || 0);
            setMetaV(event.extendedProps.meta || 0);
            setTSetupV(event.extendedProps.tiempoSetup ?? 0);
            setclienteV(event.extendedProps.cliente || '');
            calcFechaFin(event.title || '', lineSelect, event.extendedProps.meta || 0, startLocal);
        }

        setOpenPoper(false);
        setOpenP(true);
    };
    const handleCloseP1 = () => {
        requestSearch('');
        setOpenP1(false);
    };

    const handlePopUpP1 = () => {
        setOpenP1(true);
    };

    const getEnum = useCallback(async () => {
        const data1 = await fetch(
            `${process.env.REACT_APP_SERVICE_ENDPOINT}/MicroServiciosController?categoria=TipoCalendario`,
            {
                method: 'GET',
                headers: {
                    authorization: `Bearer ${tokenSessionObject.token}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            }
        );

        const values1 = await data1.json();

        if (data1.status !== 400) {
            setTipoCalendario(values1);
        }
    }, [tokenSessionObject.token]); // Dependencia de tokenSessionObject.token

    useEffect(() => {
        getLines();
        orderSin();
        getEnum();
        // La carga inicial de órdenes la dispara el useEffect dependiente de `lines`
        // (más abajo) una vez que hay una línea seleccionada; llamar aquí a
        // handleDateUpdateEvents provocaba un request ordenesFecha?linea= vacío (400).
    }, [getEnum, getLines, orderSin]);

    useEffect(() => {
        if (lines.length > 0 && lineSelect === '') {
            setSelectLine(lines[0].id);
            handleDateUpdateEvents(lines[0].id);
        }
    }, [lines, lineSelect, handleDateUpdateEvents]);

    useEffect(() => {
        if (tipoCalendario.length > 0 && tipoCalendarioIsSelect === '') {
            setTipoCalendarioIsSelect(tipoCalendario[0].codigo);
        }
    }, [tipoCalendario, tipoCalendarioIsSelect]);

    useEffect(() => {
        lines.forEach((line, index) => {
            if (line.id === lineSelect) {
                setIndi(index);
            }
        });
    }, [lineSelect, lines]);

    useEffect(() => {
        if (resW === 0) {
            arg.revert();
        } else if (resW === 1) {
            let orPro = 0;
            if (arg.event.extendedProps.tipo >= 2) {
                orPro = null;
            } else {
                orPro = arg.event.title;
            }

            const delOrOSer = {
                corrida: arg.event.extendedProps.corrida,
                linea: lineSelect,
                ordenProd: orPro,
                tipo: arg.event.extendedProps.tipo,
                fechaIni: convertToUTC(arg.event.startStr),
                fechaFin: convertToUTC(arg.event.endStr),
                tiempoSetup: arg.event.extendedProps.tiempoSetup,
                meta: 0,
                descripcion: arg.event.extendedProps.descripcion,
                cantidad: arg.event.extendedProps.cantidad,
            };

            fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT}/Calendario/editarOrdenProgramada`, {
                method: 'PUT',
                body: JSON.stringify(delOrOSer),
                headers: {
                    authorization: `Bearer ${tokenSessionObject.token}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            }).then(async (response) => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data1 = isJson && (await response.json());

                // check for error response
                if (!response.ok) {
                    // get error message from body or default to response status
                    const error = (data1 && data1.message) || response.status;
                    return Promise.reject(error);
                }
            });
        }
        setResW();
    }, [arg, lineSelect, resW, tokenSessionObject.token]);

    return (
        <div className={`${classes6.root} calendar-page`}>
            <Grid container spacing={2} className="calendar-title-section">
                <Grid item xs={12}>
                    <Paper className={classes6.paper}>
                        <h1 className="titulo">Calendario de producción</h1>
                        <p className="desc">
                            Visualiza y gestiona la programación de órdenes por línea. Arrastra los
                            eventos para reprogramar o selecciona una franja horaria para crear una
                            nueva orden.
                        </p>
                    </Paper>
                </Grid>
            </Grid>
            <Snackbar
                open={openT}
                autoHideDuration={6000}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                onClose={handleCloseT}
            >
                <div className="calendar-notif">
                    <AlertTriangle
                        size={20}
                        strokeWidth={2}
                        color="#fff"
                        className="calendar-notif__icon"
                    />
                    <span className="calendar-notif__msg">Existen órdenes sin programar</span>
                    <div className="calendar-notif__progress" />
                </div>
            </Snackbar>
            <div>
                <Dialog
                    open={open}
                    ref={dialogRef}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle id="alert-dialog-slide-title">
                        Informacion de la orden:
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                            {infOrder.map((info) => (
                                <li key={info}>{info}</li>
                            ))}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button className="popup-button-p" onClick={handleClose}>
                            Cerrar
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
            <div className={classes1.root}>
                <Popper
                    open={openPoper}
                    className="popperconf"
                    anchorEl={anchorEle}
                    placement="left"
                    transition
                    disablePortal={false}
                    modifiers={{
                        flip: {
                            enabled: true,
                        },
                        preventOverflow: {
                            enabled: true,
                            boundariesElement: 'scrollParent',
                        },
                    }}
                >
                    {({ TransitionProps }) => (
                        <Fade {...TransitionProps} timeout={500}>
                            <Paper>
                                <div className="popperhead">
                                    <span className="popper-event-dot" />
                                    <span className="popperhead-title">Detalles</span>
                                    <button
                                        className="popper-close-btn"
                                        onClick={() => setOpenPoper(false)}
                                    >
                                        <X size={16} strokeWidth={2.5} />
                                    </button>
                                    <ModalS
                                        openM={openM}
                                        popupTitle={
                                            <div className="icon-big">
                                                <Trash size={120} color="#7D7F90" />
                                            </div>
                                        }
                                        popupBody={
                                            <div className="popup-delete1">
                                                <div className="message">
                                                    ¿Está Seguro Que Desea Eliminar la Orden de la
                                                    linea: {lines[indi].nombre}?
                                                </div>

                                                <div className="popupbottom">
                                                    <div className="popupbpd4">
                                                        <Button
                                                            variant="outlined"
                                                            color="primary"
                                                            className="popup-button"
                                                            onClick={handleCloseM}
                                                            fullWidth
                                                        >
                                                            Cancelar
                                                        </Button>
                                                    </div>
                                                </div>
                                                <div className="popupbpd5">
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        type="submit"
                                                        className="popup-button"
                                                        onClick={deleteOrderOrService}
                                                        fullWidth
                                                    >
                                                        Eliminar
                                                    </Button>
                                                </div>
                                            </div>
                                        }
                                    />
                                </div>
                                <div className="popper-body">
                                    {infOrder.map((info) => {
                                        const colonIdx = info.indexOf(':');
                                        if (colonIdx === -1)
                                            return (
                                                <p key={info} className="popper-field">
                                                    {info}
                                                </p>
                                            );
                                        const label = info.slice(0, colonIdx + 1);
                                        const value = info.slice(colonIdx + 1);
                                        return (
                                            <p key={info} className="popper-field">
                                                <span className="popper-field-label">{label}</span>
                                                <span className="popper-field-value">{value}</span>
                                            </p>
                                        );
                                    })}
                                </div>
                                <div className="popper-actions">
                                    <Button onClick={handleEditEvent}>
                                        <Pencil size={20} />
                                        Editar
                                    </Button>
                                    <Button onClick={handleOpenM}>
                                        <Trash size={20} />
                                        Borrar
                                    </Button>
                                </div>
                            </Paper>
                        </Fade>
                    )}
                </Popper>
            </div>

            <div>
                <Dialog
                    open={openD}
                    ref={dialogDRef}
                    TransitionComponent={Transition}
                    keepMounted
                    popupsbclass="popupbp"
                    onClose={handleCloseD}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle className="popuphead2" id="alert-dialog-slide-title">
                        <h3 className="popuptitled">Crear Evento</h3>
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText className="popupbody3" id="alert-dialog-description">
                            {infEvent}
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Paper className={classes5.paper}>
                            <ModalR
                                open={openP}
                                popupsbclass="popupbp"
                                popupFlag={false}
                                popupTitle={
                                    <div className="cal-event-head">
                                        <h3 className="cal-event-head__title">
                                            {isEditing ? 'Editar evento' : 'Nuevo evento'}
                                        </h3>
                                        <div className="cal-event-head__right">
                                            <FormControl className="cal-event-head__select">
                                                <InputLabel id="select-line">Tipo</InputLabel>
                                                <Select
                                                    labelId="select-line"
                                                    onChange={showformOrden}
                                                    value={selectedForm}
                                                >
                                                    <MenuItem value="orden">Orden</MenuItem>
                                                    <MenuItem value="servicio">Servicio</MenuItem>
                                                </Select>
                                            </FormControl>
                                            <IconButton
                                                className="cal-event-head__close"
                                                onClick={handleCloseP}
                                                size="small"
                                            >
                                                <X size={18} />
                                            </IconButton>
                                        </div>
                                    </div>
                                }
                                popupBody={
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <div className="cal-event-body">
                                            <Grid container justify="center">
                                                <Grid
                                                    item
                                                    xs={12}
                                                    className={
                                                        showContent
                                                            ? 'cal-toggle-block'
                                                            : 'cal-toggle-hidden'
                                                    }
                                                >
                                                    <form onSubmit={(info) => postNewOrd(info)}>
                                                        <div className="cal-event-date-stack">
                                                            <KeyboardDateTimePicker
                                                                label="Fecha inicial"
                                                                value={
                                                                    fechaIni
                                                                        ? new Date(fechaIni)
                                                                        : null
                                                                }
                                                                onChange={(date) => {
                                                                    const val =
                                                                        date && isValidDate(date)
                                                                            ? fmtDate(
                                                                                  date,
                                                                                  "yyyy-MM-dd'T'HH:mm"
                                                                              )
                                                                            : '';
                                                                    setFechaIni(val);
                                                                    if (metaV && ordenV && val) {
                                                                        calcFechaFin(
                                                                            ordenV,
                                                                            lineSelect,
                                                                            Number(metaV) || 0,
                                                                            val
                                                                        );
                                                                    }
                                                                }}
                                                                format="dd/MM/yyyy HH:mm"
                                                                ampm={false}
                                                                inputVariant="standard"
                                                                fullWidth
                                                                InputLabelProps={{ shrink: true }}
                                                            />
                                                            <div className="cal-event-fecha-fin">
                                                                <KeyboardDateTimePicker
                                                                    label="Fecha final"
                                                                    value={
                                                                        fechaFinO
                                                                            ? new Date(fechaFinO)
                                                                            : null
                                                                    }
                                                                    onChange={(date) =>
                                                                        setFechaFinO(
                                                                            date &&
                                                                                isValidDate(date)
                                                                                ? fmtDate(
                                                                                      date,
                                                                                      "yyyy-MM-dd'T'HH:mm"
                                                                                  )
                                                                                : ''
                                                                        )
                                                                    }
                                                                    format="dd/MM/yyyy HH:mm"
                                                                    ampm={false}
                                                                    inputVariant="standard"
                                                                    disabled={fechaFinE}
                                                                    fullWidth
                                                                    InputLabelProps={{
                                                                        shrink: true,
                                                                    }}
                                                                />
                                                                <FormControlLabel
                                                                    className="cal-event-check"
                                                                    control={
                                                                        <Checkbox
                                                                            checked={checked}
                                                                            onChange={
                                                                                handleChangeCheck
                                                                            }
                                                                            color="primary"
                                                                            inputProps={{
                                                                                'aria-label':
                                                                                    'secondary checkbox',
                                                                            }}
                                                                        />
                                                                    }
                                                                    label="Modificar"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="cal-event-buscar">
                                                            <Paper className={classes3.paper}>
                                                                <ModalR
                                                                    forwardRef={popUpSelectOrder}
                                                                    colorButton="primary"
                                                                    open={openP1}
                                                                    buttonClass="popup-button"
                                                                    popupsbclass="popupbp"
                                                                    popupFlag={true}
                                                                    popupTitle={
                                                                        <div className="popuphead4">
                                                                            <h2 className="popuptitle">
                                                                                Buscar Orden
                                                                            </h2>
                                                                            <p className="popuptitled">
                                                                                Seleccione una orden
                                                                            </p>
                                                                        </div>
                                                                    }
                                                                    popupBody={
                                                                        <div className="popupbody1">
                                                                            <div>
                                                                                <div className="calendar-datagrid-box">
                                                                                    <DataGrid
                                                                                        components={{
                                                                                            Toolbar:
                                                                                                QuickSearchToolbar,
                                                                                        }}
                                                                                        componentsProps={{
                                                                                            toolbar:
                                                                                                {
                                                                                                    value: searchText,
                                                                                                    onChange:
                                                                                                        (
                                                                                                            event
                                                                                                        ) =>
                                                                                                            requestSearch(
                                                                                                                event
                                                                                                                    .target
                                                                                                                    .value
                                                                                                            ),

                                                                                                    clearSearch:
                                                                                                        () =>
                                                                                                            requestSearch(
                                                                                                                ''
                                                                                                            ),
                                                                                                },
                                                                                        }}
                                                                                        localeText={
                                                                                            esES
                                                                                                .props
                                                                                                .MuiDataGrid
                                                                                                .localeText
                                                                                        }
                                                                                        rows={rows}
                                                                                        disableColumnFilter
                                                                                        disableColumnMenu
                                                                                        hideFooterRowCount={
                                                                                            true
                                                                                        }
                                                                                        hideFooterSelectedRowCount={
                                                                                            true
                                                                                        }
                                                                                        disableDensitySelector
                                                                                        columns={
                                                                                            columns
                                                                                        }
                                                                                        pageSize={
                                                                                            25
                                                                                        }
                                                                                        checkboxSelection
                                                                                        selectionModel={
                                                                                            selectedRows
                                                                                        }
                                                                                        onSelectionModelChange={(
                                                                                            info
                                                                                        ) => {
                                                                                            handleDataSelect(
                                                                                                info
                                                                                            );
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            </div>

                                                                            <div className="popupbottom1">
                                                                                <div className="popupbpd7">
                                                                                    <Button
                                                                                        variant="outlined"
                                                                                        color="primary"
                                                                                        className="popup-button-s"
                                                                                        onClick={
                                                                                            handleCloseP1
                                                                                        }
                                                                                        fullWidth
                                                                                    >
                                                                                        cancelar
                                                                                    </Button>
                                                                                </div>
                                                                            </div>
                                                                            <div className="popupbpd6">
                                                                                <Button
                                                                                    variant="contained"
                                                                                    color="primary"
                                                                                    className="popup-button"
                                                                                    onClick={
                                                                                        handleSelOrder
                                                                                    }
                                                                                    type="submit"
                                                                                    fullWidth
                                                                                >
                                                                                    Seleccionar
                                                                                    Orden
                                                                                </Button>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                />

                                                                <div>
                                                                    <Button
                                                                        variant="contained"
                                                                        color="primary"
                                                                        className="popup-button"
                                                                        onClick={handlePopUpP1}
                                                                        fullWidth
                                                                    >
                                                                        <div>
                                                                            <Search
                                                                                size={18}
                                                                                className="icon"
                                                                            />
                                                                        </div>
                                                                        Buscar Orden
                                                                    </Button>
                                                                </div>
                                                            </Paper>
                                                        </div>
                                                        <div className="cal-event-details">
                                                            <p className="cal-event-details__head">
                                                                Detalles de la orden
                                                            </p>
                                                            <div className="cal-event-details__body">
                                                                <Grid container spacing={1}>
                                                                    <Grid item xs={6}>
                                                                        <TextField
                                                                            id="orden"
                                                                            disabled
                                                                            label="Número Orden"
                                                                            value={ordenV}
                                                                            fullWidth
                                                                            InputProps={{
                                                                                readOnly: true,
                                                                            }}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={6}>
                                                                        <TextField
                                                                            id="sku"
                                                                            disabled
                                                                            label="SKU"
                                                                            value={skuV}
                                                                            fullWidth
                                                                            InputProps={{
                                                                                readOnly: true,
                                                                            }}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={12}>
                                                                        <TextField
                                                                            id="nombre"
                                                                            disabled
                                                                            label="Nombre del producto"
                                                                            value={productoV}
                                                                            fullWidth
                                                                            InputProps={{
                                                                                readOnly: true,
                                                                            }}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={3}>
                                                                        <TextField
                                                                            id="total"
                                                                            disabled
                                                                            label="Total"
                                                                            value={cantidadV}
                                                                            fullWidth
                                                                            InputProps={{
                                                                                readOnly: true,
                                                                            }}
                                                                        />
                                                                    </Grid>
                                                                    {!isEditing && (
                                                                        <>
                                                                            <Grid item xs={3}>
                                                                                <TextField
                                                                                    id="producidas"
                                                                                    disabled
                                                                                    label="Producidas"
                                                                                    value={
                                                                                        producidasV
                                                                                    }
                                                                                    fullWidth
                                                                                    InputProps={{
                                                                                        readOnly: true,
                                                                                    }}
                                                                                />
                                                                            </Grid>
                                                                            <Grid item xs={3}>
                                                                                <TextField
                                                                                    id="enCalendario"
                                                                                    disabled
                                                                                    label="En Calendario"
                                                                                    value={
                                                                                        enCalendarioV
                                                                                    }
                                                                                    fullWidth
                                                                                    InputProps={{
                                                                                        readOnly: true,
                                                                                    }}
                                                                                />
                                                                            </Grid>
                                                                            <Grid item xs={3}>
                                                                                <TextField
                                                                                    id="restan"
                                                                                    disabled
                                                                                    label="Restan"
                                                                                    value={restanV}
                                                                                    fullWidth
                                                                                    InputProps={{
                                                                                        readOnly: true,
                                                                                    }}
                                                                                />
                                                                            </Grid>
                                                                        </>
                                                                    )}
                                                                    {showCliente && (
                                                                        <Grid item xs={4}>
                                                                            <TextField
                                                                                id="cliente"
                                                                                disabled
                                                                                label="Cliente"
                                                                                value={clienteV}
                                                                                fullWidth
                                                                                InputProps={{
                                                                                    readOnly: true,
                                                                                }}
                                                                            />
                                                                        </Grid>
                                                                    )}
                                                                </Grid>
                                                            </div>
                                                        </div>
                                                        <div className="cal-event-meta">
                                                            <TextField
                                                                id="meta"
                                                                label="Meta"
                                                                type="number"
                                                                value={metaV}
                                                                fullWidth
                                                                error={Boolean(metaError)}
                                                                helperText={metaError}
                                                                onChange={(e) => handleMeta(e)}
                                                            />
                                                            <TextField
                                                                id="duracion"
                                                                disabled
                                                                label="Duración/minutos"
                                                                value={duracionV}
                                                                fullWidth
                                                                InputProps={{ readOnly: true }}
                                                            />
                                                            <TextField
                                                                id="tSetup"
                                                                label="Tiempo Setup"
                                                                type="number"
                                                                value={tSetupV}
                                                                fullWidth
                                                                onChange={(e) =>
                                                                    setTSetupV(e.target.value)
                                                                }
                                                            />
                                                        </div>

                                                        <div className="cal-event-actions">
                                                            <Button
                                                                variant="outlined"
                                                                color="primary"
                                                                className="popup-button-s"
                                                                onClick={handleCloseP}
                                                                disabled={isSavingService}
                                                            >
                                                                Cancelar
                                                            </Button>
                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                className="popup-button"
                                                                onClick={postNewOrd}
                                                            >
                                                                {isEditing
                                                                    ? 'Guardar cambios'
                                                                    : 'Programar orden'}
                                                            </Button>
                                                        </div>
                                                    </form>
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    className={
                                                        showContent
                                                            ? 'cal-toggle-hidden'
                                                            : 'cal-toggle-block'
                                                    }
                                                >
                                                    <form onSubmit={(info) => postNewService(info)}>
                                                        <div className="cal-event-service-fields">
                                                            <FormControl
                                                                className={classes9.formControl}
                                                            >
                                                                <InputLabel id="parosEspeciales-label">
                                                                    SELECCIONE UN PARO AUTORIZADO
                                                                </InputLabel>
                                                                <Select
                                                                    labelId="parosEspeciales-label"
                                                                    id="parosEspeciales"
                                                                    value={tipoCalendarioIsSelect}
                                                                    onOpen={handleParoOpen}
                                                                    onClose={handleParoClose}
                                                                    onChange={(event, index) =>
                                                                        handleChangeParoAut(
                                                                            event,
                                                                            index
                                                                        )
                                                                    }
                                                                    disabled={isSavingService}
                                                                    MenuProps={{
                                                                        anchorEl: paroAnchorEl,
                                                                        getContentAnchorEl: null,
                                                                        anchorOrigin: {
                                                                            vertical: 'bottom',
                                                                            horizontal: 'left',
                                                                        },
                                                                        transformOrigin: {
                                                                            vertical: 'top',
                                                                            horizontal: 'left',
                                                                        },
                                                                    }}
                                                                >
                                                                    {tipoCalendario.map(
                                                                        (tipoCalendar) => (
                                                                            <MenuItem
                                                                                value={
                                                                                    tipoCalendar.codigo
                                                                                }
                                                                                key={
                                                                                    tipoCalendar.codigo
                                                                                }
                                                                            >
                                                                                {
                                                                                    tipoCalendar.nombre
                                                                                }
                                                                            </MenuItem>
                                                                        )
                                                                    )}
                                                                </Select>
                                                            </FormControl>
                                                            <TextField
                                                                id="servicio"
                                                                name="ordenProd"
                                                                label="DESCRIPCIÓN"
                                                                required
                                                                value={descServ}
                                                                onChange={(e) =>
                                                                    setDescServ(e.target.value)
                                                                }
                                                                disabled={isSavingService}
                                                                fullWidth
                                                            />
                                                            <div className="cal-event-dates">
                                                                <KeyboardDateTimePicker
                                                                    label="Fecha inicial"
                                                                    value={
                                                                        fechaIni
                                                                            ? new Date(fechaIni)
                                                                            : null
                                                                    }
                                                                    onChange={(date) =>
                                                                        setFechaIni(
                                                                            date &&
                                                                                isValidDate(date)
                                                                                ? fmtDate(
                                                                                      date,
                                                                                      "yyyy-MM-dd'T'HH:mm"
                                                                                  )
                                                                                : ''
                                                                        )
                                                                    }
                                                                    format="dd/MM/yyyy HH:mm"
                                                                    ampm={false}
                                                                    inputVariant="standard"
                                                                    disabled={isSavingService}
                                                                    fullWidth
                                                                    InputLabelProps={{
                                                                        shrink: true,
                                                                    }}
                                                                />
                                                                <KeyboardDateTimePicker
                                                                    label="Fecha final"
                                                                    value={
                                                                        fechaFin
                                                                            ? new Date(fechaFin)
                                                                            : null
                                                                    }
                                                                    onChange={(date) =>
                                                                        setFechaFin(
                                                                            date &&
                                                                                isValidDate(date)
                                                                                ? fmtDate(
                                                                                      date,
                                                                                      "yyyy-MM-dd'T'HH:mm"
                                                                                  )
                                                                                : ''
                                                                        )
                                                                    }
                                                                    format="dd/MM/yyyy HH:mm"
                                                                    ampm={false}
                                                                    inputVariant="standard"
                                                                    disabled={isSavingService}
                                                                    fullWidth
                                                                    InputLabelProps={{
                                                                        shrink: true,
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="cal-event-actions">
                                                            <Button
                                                                variant="outlined"
                                                                color="primary"
                                                                className="popup-button-s"
                                                                onClick={handleCloseP}
                                                            >
                                                                Cancelar
                                                            </Button>
                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                className="popup-button"
                                                                type="submit"
                                                                disabled={isSavingService}
                                                                startIcon={
                                                                    isSavingService ? (
                                                                        <CircularProgress
                                                                            size={18}
                                                                            color="inherit"
                                                                        />
                                                                    ) : null
                                                                }
                                                            >
                                                                {isEditing
                                                                    ? 'Guardar cambios'
                                                                    : 'Crear nuevo servicio'}
                                                            </Button>
                                                        </div>
                                                    </form>
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </MuiPickersUtilsProvider>
                                }
                            />
                        </Paper>
                        <div>
                            <div className="popupbottom">
                                <div className="popupbpd">
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        className="popup-button-s"
                                        onClick={handleCloseD}
                                        disabled={isSavingService}
                                        fullWidth
                                    >
                                        cancelar
                                    </Button>
                                </div>
                            </div>
                            <div className="popupbpd8">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className="popup-button"
                                    onClick={handlePopUpP}
                                    fullWidth
                                >
                                    Sí
                                </Button>
                            </div>
                        </div>
                    </DialogActions>
                </Dialog>
            </div>
            <div className="body-calendar">
                <Grid container className="container-controls">
                    <Grid item xs={6}>
                        <InputLabel id="selectLine" color="primary" className="label-line">
                            Seleccione una Línea
                        </InputLabel>
                        <Select
                            labelId="selectLine"
                            id="Line Select"
                            value={lineSelect}
                            className="select-line"
                        >
                            {lines.map((item, index) => (
                                <MenuItem
                                    value={item.id}
                                    key={item.id}
                                    onClick={() => {
                                        setSelectLine(item.id);
                                        handleDateUpdateEvents(item.id);
                                    }}
                                >
                                    {item.nombre}
                                </MenuItem>
                            ))}
                        </Select>
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            id="standard-basic"
                            label="BUSCAR ORDEN..."
                            className="search-product"
                            value={value}
                            onChange={(e) => SearchOrder(e.target.value)}
                        />
                    </Grid>
                </Grid>
                <div className="calendar-card">
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <FullCalendar
                            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                            initialView={calendarWeeks}
                            contentHeight={Math.max(480, window.innerHeight - 290)}
                            scrollTime={`${String(Math.max(0, new Date().getHours() - 1)).padStart(2, '0')}:00:00`}
                            scrollTimeReset={false}
                            // progressiveEventRendering={true}
                            allDaySlot={false}
                            // id="calendrio"
                            locale={esLocale}
                            nowIndicator={true}
                            eventOverlap={false}
                            themeSystem="bootstrap5"
                            ref={calendarComponentRef}
                            editable={true}
                            selectable={true}
                            selectMirror={true}
                            dayMaxEvents={true}
                            eventClick={(info) => handleClick(info)}
                            select={(info) => handleSelect(info)}
                            eventDrop={(info) => handleDrop(info, 0)}
                            eventResize={(info) => handleDrop(info, 1)}
                            events={calendarEvents}
                            slotMinTime={
                                process.env.REACT_APP_THEME === 'tecnoTheme'
                                    ? '06:00:00'
                                    : '00:00:00'
                            }
                            slotMaxTime={
                                process.env.REACT_APP_THEME === 'tecnoTheme'
                                    ? '18:00:00'
                                    : '24:00:00'
                            }
                            // hiddenDays={[0]} // esconder el domingo
                            businessHours={{
                                // days of week. an array of zero-based day of week integers (0=Sunday)
                                daysOfWeek: [0, 1, 2, 3, 4, 5, 6], // dias habiles en el calendario

                                startTime: '00:00', // a start time (10am in this example)
                                endTime: '24:00', // an end time (6pm in this example)
                            }}
                            slotDuration="00:15"
                            headerToolbar={{
                                right: 'espacio excel title prevYear prev next nextYear',
                                center: '',
                                left: 'espacio dayGridMonth espacio espacio espacio timeGridWeek espacio espacio  timeGridDay espacio espacio ',
                            }}
                            slotLabelFormat={{
                                hour: 'numeric',
                                minute: '2-digit',
                                hour12: true,
                                omitZeroMinute: false,
                                meridiem: 'short',
                            }}
                            dayHeaderFormat={{
                                weekday: 'long',
                            }}
                            customButtons={{
                                excel: {
                                    text: [
                                        <FileDownload
                                            key="excel-ico"
                                            size={25}
                                            strokeWidth={1.5}
                                            color="black"
                                        />,
                                    ],
                                    click: function () {
                                        ExportToExcel();
                                    },
                                },
                                prev: {
                                    click: function () {
                                        setOpenPoper(false);

                                        calendarComponentRef.current.getApi().prev();
                                        handleDateUpdateEvents();
                                    },
                                },
                                next: {
                                    click: function () {
                                        setOpenPoper(false);

                                        calendarComponentRef.current.getApi().next();
                                        handleDateUpdateEvents();
                                    },
                                },

                                prevYear: {
                                    click: function () {
                                        setOpenPoper(false);

                                        calendarComponentRef.current.getApi().prevYear();
                                        handleDateUpdateEvents();
                                    },
                                },
                                nextYear: {
                                    click: function () {
                                        setOpenPoper(false);

                                        calendarComponentRef.current.getApi().nextYear();
                                        handleDateUpdateEvents();
                                    },
                                },

                                dayGridMonth: {
                                    text: [
                                        <div key="ico-mes" className="iconCalendar">
                                            {calendarWeeks === 'dayGridMonth' && (
                                                <div className="calendar-view-btn calendar-view-btn--active">
                                                    <CalendarEvent
                                                        size={25}
                                                        strokeWidth={1.5}
                                                        color={primColor}
                                                    />
                                                    &nbsp;Mes
                                                </div>
                                            )}
                                            {calendarWeeks !== 'dayGridMonth' && (
                                                <div className="calendar-view-btn calendar-view-btn--inactive">
                                                    <CalendarEvent
                                                        size={25}
                                                        strokeWidth={1.5}
                                                        color="#5f606f"
                                                    />
                                                    &nbsp;Mes
                                                </div>
                                            )}
                                        </div>,
                                    ],
                                    click: function () {
                                        setOpenPoper(false);
                                        setCalendarWeeks('dayGridMonth');
                                        calendarComponentRef.current
                                            .getApi()
                                            .changeView('dayGridMonth');
                                        handleDateUpdateEvents();
                                    },
                                },
                                timeGridWeek: {
                                    className: 'buttonCalendar',
                                    text: [
                                        <div key="ico-semana" className="iconCalendar">
                                            {calendarWeeks === 'timeGridWeek' && (
                                                <div className="calendar-view-btn calendar-view-btn--active">
                                                    <CalendarMinus
                                                        size={25}
                                                        strokeWidth={1.5}
                                                        color={primColor}
                                                    />
                                                    &nbsp;Semana
                                                </div>
                                            )}
                                            {calendarWeeks !== 'timeGridWeek' && (
                                                <div className="calendar-view-btn calendar-view-btn--inactive">
                                                    <CalendarMinus
                                                        size={25}
                                                        strokeWidth={1.5}
                                                        color="#5f606f"
                                                    />
                                                    &nbsp;Semana
                                                </div>
                                            )}
                                        </div>,
                                    ],
                                    click: function () {
                                        setOpenPoper(false);
                                        setCalendarWeeks('timeGridWeek');
                                        calendarComponentRef.current
                                            .getApi()
                                            .changeView('timeGridWeek');
                                        handleDateUpdateEvents();
                                    },
                                },
                                timeGridDay: {
                                    className: 'buttonCalendar',
                                    text: [
                                        <div key="ico-dia" className="iconCalendar">
                                            {calendarWeeks === 'timeGridDay' && (
                                                <div className="calendar-view-btn calendar-view-btn--active">
                                                    <CalendarStats
                                                        size={25}
                                                        strokeWidth={1.5}
                                                        color={primColor}
                                                    />
                                                    &nbsp;Día
                                                </div>
                                            )}
                                            {calendarWeeks !== 'timeGridDay' && (
                                                <div className="calendar-view-btn calendar-view-btn--inactive">
                                                    <CalendarStats
                                                        size={25}
                                                        strokeWidth={1.5}
                                                        color="#5f606f"
                                                    />
                                                    &nbsp;Día
                                                </div>
                                            )}
                                        </div>,
                                    ],
                                    click: function () {
                                        setOpenPoper(false);
                                        setCalendarWeeks('timeGridDay');
                                        calendarComponentRef.current
                                            .getApi()
                                            .changeView('timeGridDay');
                                        handleDateUpdateEvents();
                                    },
                                },
                            }}
                            // eventLimitText={'más'}
                            // eventLimitClick={'popover'}
                            // eventLimit={true}
                        />
                    </Grid>
                </div>
            </div>
            <div>
                <Snackbar open={openS} autoHideDuration={5000} onClose={handleCloseS}>
                    <Alert onClose={handleCloseS} severity="error">
                        {mensaje}
                    </Alert>
                </Snackbar>
                <Snackbar open={openSuccess} autoHideDuration={4000} onClose={handleCloseSuccess}>
                    <Alert onClose={handleCloseSuccess} severity="success">
                        {mensajeExito}
                    </Alert>
                </Snackbar>
                <Snackbar
                    open={openWarn}
                    autoHideDuration={4000}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    onClose={handleCloseWarn}
                >
                    <Alert onClose={handleCloseWarn} severity="warning">
                        {mensajeWarn}
                    </Alert>
                </Snackbar>
            </div>
            <div>
                <ModalS
                    openM={openW}
                    popupTitle={
                        <div className="icon-big">
                            <HandMove size={120} color="#7D7F90" />
                        </div>
                    }
                    popupBody={
                        <div className="popup-mover">
                            <div className="message1">
                                ¿Está Seguro Que Desea Mover La Orden/Servicio De Una fecha Anterior
                                a una Fecha Posterior a La Feha Actual?
                            </div>

                            <div className="popupbpd-mover-cancelar">
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    className="popup-button"
                                    onClick={(e) => handleResW(0)}
                                    fullWidth
                                >
                                    Cancelar
                                </Button>
                            </div>

                            <div className="popupbpd-mover-si">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                    className="popup-button"
                                    onClick={(e) => handleResW(1)}
                                    fullWidth
                                >
                                    Sí
                                </Button>
                            </div>
                        </div>
                    }
                />
            </div>
            <Dialog
                open={openDefaultCapDialog}
                TransitionComponent={Transition}
                keepMounted
                classes={{ root: 'dialog-on-top', paper: 'dialog-default-cap-paper' }}
                onClose={() => {
                    setOpenDefaultCapDialog(false);
                    setSelectedRows([]);
                    setPendingOrderProps(null);
                }}
                aria-labelledby="default-cap-dialog-title"
                aria-describedby="default-cap-dialog-description"
            >
                <DialogTitle className="popuphead2" id="default-cap-dialog-title">
                    <h3 className="popuptitled">Producto no configurado en esta línea</h3>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText className="popupbody3" id="default-cap-dialog-description">
                        Este producto no puede fabricarse en la línea seleccionada. ¿Deseas
                        continuar usando las capacidades predeterminadas de la línea?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="outlined"
                        color="primary"
                        className="popup-button-s"
                        onClick={() => {
                            setOpenDefaultCapDialog(false);
                            setSelectedRows([]);
                            setPendingOrderProps(null);
                        }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        className="popup-button"
                        onClick={() => {
                            setOpenDefaultCapDialog(false);
                            getFechafinConDefaults(pendingOrderProps);
                            setPendingOrderProps(null);
                        }}
                    >
                        Usar capacidades default
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};
export default CalendarProduc;
